import * as React from 'react';
import { ClassName } from '../../utils/utils';

interface IButtonProps {
  children?: any;
  size?: string;
  color?: string;
  type?: string;
  disabled?: boolean;
  className?: string;
  style?: any;
  onClick?: (e?: React.MouseEvent<HTMLElement>) => void;
}

const Button = (props: IButtonProps) => {
  const name: string = 'btn';
  const { children, size, color, type, onClick, style, disabled, className } = props;
  return (
    <button
      onClick={onClick}
      disabled={disabled}
      className={
        ClassName(name, [size, color, type, className])
        + (disabled ? ' btn--isDisabled' : '')
      }
      style={style}
    >
      {children}
    </button>
  );
};

export default Button;



// WEBPACK FOOTER //
// ./src/modules/Button/Button.tsx